import {
  CardHeader,
  Dialog,
  DialogContent,
  Grid,
  Loading,
  MaskedInput,
  IconButton,
  Button,
  TextField,
} from "../../../../../components";
import { useEffect, useRef, useState } from "react";
import {
  notification,
  AdzapService,
  MensagemPersonalizadaService,
  SessionService,
  NfSaidaService,
} from "../../../../../services";
import { responseErros, voltar } from "../../../../../utils";
import { boletosHelper } from "../../../../../helpers/boletos.helper";

const adzapService = new AdzapService();
const mensagemPersonalizadaService = new MensagemPersonalizadaService();
const sessionService = new SessionService();
const nfSaidaService = new NfSaidaService();

const EnvioWhatsappNfeDialog = ({
  open,
  setOpen,
  nfSaida,
  envioMensagemBoleto,
  listaIdImpressao,
  emitirAposCadastro,
  initialCollapses,
}) => {
  const componentRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [celular, setCelular] = useState("");
  const [nomeCompletoCliente, setNomeCompletoCliente] = useState("");
  const [erroCelular, setErroCelular] = useState(false);
  const usuario = sessionService.getUsuario();

  useEffect(() => {
    if (open && nfSaida?.cliente?.id) {
      setCelular(nfSaida?.cliente?.celular);
      setNomeCompletoCliente(nfSaida?.cliente?.nomeRazaoSocial);
    }
  }, [open]);

  const handleInputChange = (event) => {
    setErroCelular(false);
    setCelular(event.target.value);
  };

  function handleCloseDialog() {
    setLoading(false);
    setCelular("");
    setOpen(false);
    initialCollapses();
    voltar();
  }

  async function handleSubmit() {
    if (!celular || celular.replace(/\D/g, "")?.length < 11) {
      notification.erroGenericos("Informe um número de celular válido");
      setErroCelular(true);
      return;
    }

    if (envioMensagemBoleto) {
      setLoading(true);
      const dadosEmpresa = sessionService.getEmpresaAndUsuario();
      await boletosHelper.enviarMensagemUnicoPdf(
        listaIdImpressao,
        `${nfSaida?.serieDocumento}/${nfSaida?.numeroDocumento}`,
        celular,
        dadosEmpresa,
      );
      setTimeout(() => {
        setLoading(false);
        setCelular("");
        setOpen(false);
        emitirAposCadastro(nfSaida);
      }, 2000);
    } else {
      if (
        nfSaida?.status === "ENVIADA" ||
        (!nfSaida?.status &&
          (nfSaida?.modelo === "65" || nfSaida?.modeloDocumento === "55"))
      ) {
        await submitEnviado();
      }

      if (
        nfSaida?.status == "FATURADA" ||
        (!nfSaida?.status && nfSaida?.modeloDocumento === "01")
      ) {
        await submitFaturado();
      }
    }
  }

  async function submitEnviado() {
    setLoading(true);
    let result = false;
    if (
      nfSaida?.status === "ENVIADA" ||
      (!nfSaida?.status &&
        (nfSaida?.modelo === "65" || nfSaida?.modeloDocumento === "55"))
    ) {
      result = await nfSaidaService.getDanfe(nfSaida.id);
    }
    if (
      nfSaida?.status == "FATURADA" ||
      (!nfSaida?.status && nfSaida?.modeloDocumento === "01")
    ) {
      result = await nfSaidaService.getDanfeSecundaria(
        nfSaida.id,
        nfSaida.empresa,
      );
    }
    setLoading(false);
    if (!result || result?.isAxiosError) {
      if (!result) {
        notification.erroGenericos("Falha ao gerar o documento para envio");
      } else {
        responseErros(result);
      }
    } else {
      if (!result?.data) {
        setLoading(false);
        notification.erroGenericos("Documento gerado não contém dados válidos");
        return;
      }
      await enviarPdf({
        file: result.data,
        docName: `NFS_Nº${nfSaida?.numeroDocumento}`,
      });
    }
  }

  async function submitFaturado() {
    setLoading(true);
    const result = await nfSaidaService.getDanfeSecundaria(
      nfSaida.id,
      nfSaida.empresa,
    );
    setLoading(false);
    if (!result.isAxiosError) {
      await enviarPdf({
        file: result.data,
        docName: `NFS_Nº${nfSaida?.numeroDocumento}`,
      });
    }
  }

  async function enviarPdf(dadosArquivo) {
    try {
      let text = "Segue NF-Saída solicitada!";
      const getPrimeiroNome = (nomeCompleto) => {
        return nomeCompleto?.split(" ")[0] || "";
      };
      const nomeCliente =
        nfSaida?.cliente?.nomeRazaoSocial || nomeCompletoCliente;
      const texto = await mensagemPersonalizadaService.getMensagem({
        contexto: "nf-saida",
        apelidoFantasia: nfSaida?.empresa?.nome,
        serieDocumento: nfSaida?.serieDocumento,
        numeroDocumento: nfSaida?.numeroDocumento,
        nomeCompletoCliente: nomeCliente,
        primeiroNomeCliente: getPrimeiroNome(nomeCliente),
        nomeUsuario: usuario?.nome,
      });

      if (!texto.isAxiosError) {
        text = texto.data;
      } else {
        return responseErros(texto);
      }

      const result = await adzapService.enviarMensagem({
        number: celular,
        type: "document",
        file: dadosArquivo.file,
        docName: dadosArquivo.docName,
        text,
      });

      if (!result.isAxiosError) {
        handleCloseDialog();
        notification.sucessoGenericos("Documento enviado com sucesso!");
      } else {
        handleCloseDialog();
        responseErros(result);
      }
    } catch (error) {
      notification.erroGenericos("Falha no envio do documento");
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <div
        style={{
          position: "absolute",
          left: "-9999px",
          width: "100%",
          maxWidth: "800px",
          padding: "20px",
          boxSizing: "border-box",
        }}
      >
        <div
          ref={componentRef}
          style={{
            width: "100%",
            display: "inline-block",
            backgroundColor: "white",
          }}
        >
          {/*     {modeloImpressao()} */}
        </div>
      </div>
      <Dialog
        fullWidth
        maxWidth={"xs"}
        open={open}
        onClose={() => handleCloseDialog()}
      >
        <CardHeader title="Envio Whatsapp" className="m-2" />
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                id="nomeCompletoCliente"
                name="nomeCompletoCliente"
                label="Nome"
                variant="outlined"
                fullWidth
                value={nomeCompletoCliente}
                onChange={(e) => setNomeCompletoCliente(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <IconButton disabled={true}>
                      <i
                        className="ph-fill ph-user"
                        style={{ fontSize: 20 }}
                      ></i>
                    </IconButton>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <MaskedInput
                id="celular"
                name="celular"
                label="Celular"
                mask="(99) 9 9999-9999"
                onChange={handleInputChange}
                margin="none"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <IconButton disabled={true}>
                      <i
                        className="ph-fill ph-device-mobile"
                        style={{ fontSize: 20 }}
                      ></i>
                    </IconButton>
                  ),
                }}
                error={erroCelular}
                value={celular || ""}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={() => handleSubmit()}
              >
                Enviar Documento
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
        <Loading loading={loading} />
      </Dialog>
    </>
  );
};

export default EnvioWhatsappNfeDialog;
